import script from "./ClaimPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ClaimPage.vue?vue&type=script&setup=true&lang=js"

import "./ClaimPage.vue?vue&type=style&index=0&id=df789316&lang=css"

const __exports__ = script;

export default __exports__